import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useBestRateNoticeOfHotelPolicy = () => {
	const { viewModel, onSetViewModel, hotelID } = useAccommodationHotelPolicyFormModelContext();
	const { isShowBestRateNotice } = viewModel;

	const onSetIsShowBestRateNotice = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isShowBestRateNotice",
					value: {
						...isShowBestRateNotice,
						value: input,
					},
				},
			]);
		},
		[isShowBestRateNotice, onSetViewModel],
	);

	return {
		isEdited: isShowBestRateNotice.isEdited,
		hasError: Boolean(isShowBestRateNotice.error),

		hotelID,
		isShowBestRateNotice,
		onSetIsShowBestRateNotice,
	};
};
